<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full">سابقه حساسیت</span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <span class="mr-5">سابقه حساسیت</span>
      <v-divider class="mt-3 mr-3"></v-divider>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="3">
        <span>آیا بیمار سابقه حساسیت دارد؟</span>
      </v-col>
      <v-radio-group v-model="hasAllergy" row>
        <v-radio label="بله" :value="true"></v-radio>
        <v-radio label="خیر" :value="false"></v-radio>
      </v-radio-group>
    </v-row>
    <v-row class="relative ma-0" :style="{ opacity: hasAllergy != true ? 0.4 : 1 }">
      <div v-if="hasAllergy != true" class="visibilForm"></div>
      <v-col cols="6">
        <v-row>
          <span class="mr-5">حساسیت دارویی</span>
          <v-divider class="mt-3 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined label="حساسیت دارویی" dense v-model="patientDrugAllergy"
              prepend-inner-icon="mdi-text mdi-18px" clearable v-on:keyup.enter="addPatientDrugAllergy()"
              clear-icon="mdi-close-circle-outline">
              <template v-slot:append-outer>
                <v-btn color="darkColor" x-small elevation="0" class="py-5 mt-n2" @click="addPatientDrugAllergy()">
                  <v-icon color="white">mdi-plus mdi-18px</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <span class="mr-5">حساسیت های دارویی انتخابی</span>
          <v-divider class="mt-3 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="card-style" height="32vh">
              <v-chip v-for="item in allAllergicItems" :key="item.id" color="darkColor" text-color="white"
                class="mr-2 mt-2">
                {{ item.title }}
                <v-icon class="mr-3" color="white" @click="deletePatientAllergyHistoryFunction(item)">
                  mdi-close mdi-18px
                </v-icon>
              </v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <span class="mr-5">حساسیت غیر دارویی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined label="حساسیت غیر دارویی" dense v-model="patientAllergy"
              prepend-inner-icon="mdi-text mdi-18px" clearable v-on:keyup.enter="addPatientAllergy()"
              clear-icon="mdi-close-circle-outline">
              <template v-slot:append-outer>
                <v-btn color="darkColor" x-small elevation="0" class="py-5 mt-n2" @click="addPatientAllergy()">
                  <v-icon color="white">mdi-plus mdi-18px</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <span class="mr-5">حساسیت های غیر دارویی انتخابی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="card-style" height="32vh">
              <v-chip v-for="item in allNotAllergicItems" :key="item.id" color="darkColor" text-color="white"
                class="mr-2 mt-2">
                {{ item.title }}
                <v-icon class="mr-3" color="white" @click="deletePatientAllergyHistoryFunction(item)">
                  mdi-close mdi-18px
                </v-icon>
              </v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (معاینات)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep8Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep8Helper';
import PatientAllergyHistoryMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientAllergyHistoryMixin';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';
export default {
  mixins: [FollowUpPatientStep8Helper, PatientAllergyHistoryMixin, SharedHelper, SharedMixin],
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
  },
  methods: {
    mounte: function () {
      this.getAllPatientAllergyHistoryFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    }
  },
};
</script>
<style scoped>
.card-style {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
}

.visibilForm {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff00;
  z-index: 1000000;
}
</style>
